export default __webpack_public_path__ + "static/media/EAST3140.34I-40853_-24172_0.9d1a644a.jpg";